import React, { useState, useEffect } from "react";
import HeaderHero from "./HeaderHero";
import "./ConfirmationPage.scss";
import SelectionSummary from "./SelectionSummary";
import { JLR_CHANNELS } from "../../data/jlrEnrollChannels";

function ConfirmationPage() {
  const [selections, setSelections] = useState({
    moveUp: "",
    luxury: "",
    dynamicInventory: "",
    inlanguage: "",
  });
  const [jlrChannelSelections, setJlrChannelSelections] = useState(null);

  useEffect(() => {
    const savedSelections = localStorage.getItem("enrollmentSelections");

    if (savedSelections) {
      const parsed = JSON.parse(savedSelections);
      if (parsed.variant === "jlr" && parsed.channels) {
        setJlrChannelSelections(parsed.channels);
      } else {
        setSelections(parsed);
      }
    }

    return () => {
      localStorage.removeItem("enrollmentSelections");
      localStorage.removeItem("dealerInfo");
    };
  }, []);

  return (
    <>
      <div>
        <HeaderHero
          title="ENROLLMENT CONFIRMATION"
          subtitle=""
          disclaimer=""
          trailingText="Summary & confirmation"
        />

        <div className="confirmation-page confirmation-page--total-only">
          <p className="confirmation-eyebrow">ENROLLMENT CONFIRMED</p>
          <p className="confirmation-page-content-title">
            YOUR PROGRAM <br /> IS BEING ACTIVATED.
          </p>
          <p className="confirmation-page-content-subtitle">
            Constellation will reach out within 24 hours to complete your
            setup.{" "}
          </p>

          <p className="confirmation-table-title">ENROLLED SERVICES</p>
          <div className="confirmation-table-content">
            <p className="confirmation-table-content-label">
              TOTAL MONTHLY INVESTMENT
            </p>
            <div className="confirmation-table-content-total">
              <span className="confirmation-table-content-amount">
                <span className="confirmation-table-content-currency">$</span>
                <SelectionSummary
                  variant={jlrChannelSelections ? "jlr" : "bmw"}
                  selections={selections}
                  channelSelections={jlrChannelSelections}
                  jlrChannels={JLR_CHANNELS}
                  showTotalNumberOnly
                  showCount={false}
                  showReimbursement={false}
                  handleSelectionChange={() => {}}
                />
              </span>
              <span className="confirmation-table-content-total-suffix">
                /mo
              </span>
            </div>
          </div>
          <div className="next-table-content">
            <p className="next-table-title">WHAT HAPPENS NEXT</p>
            <div className="next-table-row">
              <div className="next-table-row-num">01</div>
              <div className="next-table-row-text">
                Constellation reviews your enrollment and confirms service
                selection.
              </div>
            </div>
            <div className="next-table-row">
              <div className="next-table-row-num">02</div>
              <div className="next-table-row-text">
                Your account manager reaches out to complete onboarding.
              </div>
            </div>
            <div className="next-table-row">
              <div className="next-table-row-num">03</div>
              <div className="next-table-row-text">
                Campaigns go-live and run always on
              </div>
            </div>
          </div>
		  <a href="/" className="back-text">← Return to Program Home</a>
        </div>
      </div>
    </>
  );
}

export default ConfirmationPage;
